module.exports = new __parcel__URL__("incidents-preview.e6af1843.svg").toString();